import { Col, Container, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useFirestore } from "reactfire";
import "./styles.scss";
// @ts-ignore
import renderHTML from "react-render-html";
import PageHeader from "../../../components/page-header/PageHeader";

interface IntroState {
  description: string;
}

interface ErrorState {
  loading: boolean;
  descriptionError: string;
}

interface State {
  showAcceptConfirmation: boolean;
  showClearConfirmation: boolean;
}

const initIntroState: IntroState = {
  description: "",
};

const PublicLibraryHomeView = () => {
  const store = useFirestore();
  const [introState, setIntroState] = useState(initIntroState);

  useEffect(() => {
    return store
      .collection("publicCourseIntroductions")
      .onSnapshot({}, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added" || change.type === "modified") {
            setIntroState((prevState) => {
              return Object.assign(
                {},
                {
                  description: change.doc.data().description,
                }
              );
            });
          }
          if (change.type === "removed") {
            setIntroState((prevState) => {
              return Object.assign(
                {},
                {
                  description: "",
                }
              );
            });
          }
        });
      });
  }, [store]);

  return (
    <>
      <PageHeader title="Library Home" />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
        }}
      >
        <Row>
          <Col
            xs={12}
            className="text-left font-weight-bold"
            style={{ color: "rgb(7, 66, 94)", width: "100%" }}
          >
            {renderHTML(introState.description)}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PublicLibraryHomeView;
